import * as React from 'react';

import CountryAutocomplete from 'root/apps/Autocomplete/Country';
import GuiDefHiddenInput from 'root/apps/Autocomplete/GuiDefHiddenInput';

const AddressCountry = ({
  name,
  countryName,
  countryCode,
  onChange,
  onInputChange,
  className,
  autocompleteClassName,
  inputProps,
  ...rest
}) => (
  <>
    <CountryAutocomplete
      countryName={countryName}
      countryCode={countryCode}
      onChange={onChange}
      onInputChange={onInputChange}
      inputProps={{
        ...inputProps,
        'data-validation': 'checkForCreditCardInfo',
        'data-container-selector': '.view_field_box',
      }}
      className={autocompleteClassName}
      {...rest}
    />

    <GuiDefHiddenInput name={name} readOnly value={countryName} className={className} />
    <GuiDefHiddenInput name={`${name}_code`} readOnly value={countryCode} className={className} />
  </>
);

export default AddressCountry;
